import { closePopup, openPopup } from '@/popups/popup';

export function popupEmailInit() {
  $('.popup-email-accept').on('click', () => {
    /*todo действия при подтверждении*/

    closePopup($('#popup-email'));
    openPopup($('#popup-certificat'));
  });
}
